var chunkMapping = {
	"55": [
		9055
	],
	"93": [
		4093
	],
	"116": [
		1116
	],
	"153": [
		5153
	],
	"213": [
		8459,
		9161
	],
	"221": [
		1221
	],
	"305": [
		5305
	],
	"340": [
		1340
	],
	"429": [
		9429
	],
	"453": [
		8453
	],
	"537": [
		9537
	],
	"566": [
		5566
	],
	"692": [
		1692
	],
	"695": [
		1695
	],
	"705": [
		8705
	],
	"788": [
		7788
	],
	"802": [
		4802
	],
	"901": [
		3901
	],
	"988": [
		5988
	]
};
var idToExternalAndNameMapping = {
	"1116": [
		"default",
		"./IpsFederatedSearchModule",
		2914
	],
	"1221": [
		"default",
		"./SpecialUenModule",
		2914
	],
	"1340": [
		"default",
		"./CartModule",
		2914
	],
	"1692": [
		"default",
		"./CneModule",
		9458
	],
	"1695": [
		"default",
		"./ApiMarketplaceModule",
		2914
	],
	"3901": [
		"default",
		"./CommonApp",
		1628
	],
	"4093": [
		"default",
		"./PageLoaderModule",
		2190
	],
	"4802": [
		"default",
		"./IpsPaymentModule",
		2914
	],
	"5153": [
		"default",
		"./VerifyModule",
		2914
	],
	"5305": [
		"default",
		"./IpsExternalPaymentModule",
		2914
	],
	"5566": [
		"default",
		"./BuyInfoModule",
		2914
	],
	"5988": [
		"default",
		"./ContentModule",
		2190
	],
	"7788": [
		"default",
		"./RefundModule",
		2914
	],
	"8453": [
		"default",
		"./RegistryApp",
		8040
	],
	"8459": [
		"default",
		"./InstructionPageRoutes",
		8040
	],
	"8705": [
		"default",
		"./IpsPaymentSettingsModule",
		2914
	],
	"9055": [
		"default",
		"./NoticeBannerModule",
		2190
	],
	"9161": [
		"default",
		"./store",
		7986
	],
	"9429": [
		"default",
		"./SeoLoaderModule",
		2190
	],
	"9537": [
		"default",
		"./CrmModule",
		1628
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}